import {
  ElementCategoryID,
  IElementCategory,
} from '../../../models/element-categories.model';
import { ElementPropertyType } from '../../../models/element-property.model';
import {
  DEFAULT_AREAL_DENSITY_PROPERTIES,
  DEFAULT_QUANTITY_PROPERTIES,
} from '../../../models/element-quantities.model';
import {
  getElementPropertySelectionByValue,
  getValueFromConditionalNodes,
  IConditionalNode,
} from '../../../helpers/conditional-nodes.helpers';
import { otherProducts } from './other-products.helpers';
import { OTHER_PRODUCTS_SELECT_PROPERTY_NAME } from './other-product.model';
import { reusedContentProperty } from '../reused-content-property.model';
import { ProductID } from '../../../models/product.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';

// Map uses id as key since the select property stores product id (value: id in options)
const productIds: IConditionalNode<ProductID> = {
  property: OTHER_PRODUCTS_SELECT_PROPERTY_NAME,
  map: otherProducts.reduce<Record<ProductID, ProductID>>(
    (acc, { id }) => ({ ...acc, [id]: id }),
    {},
  ),
};

export const otherProductCategory: IElementCategory = {
  id: ElementCategoryID.OtherProduct,
  defaultSelectedQuantity: 'mass',
  name: 'Other product',
  properties: [
    {
      name: OTHER_PRODUCTS_SELECT_PROPERTY_NAME,
      type: ElementPropertyType.Select,
      count: otherProducts[0]?.id,
      options: OTHER_PRODUCTS_SELECT_PROPERTY_NAME,
    },
    reusedContentProperty,
    ...commonElementCategoryProperties,
  ],
  getQuantityProperties: () => ({
    ...DEFAULT_QUANTITY_PROPERTIES,
    ...DEFAULT_AREAL_DENSITY_PROPERTIES,
  }),
  // `throwIfNotFound: false` + `undefined` passthrough: tolerate transient
  // Select counts (e.g. a stale option id after the otherProducts list
  // shrinks). `undefined` skips enrichment so existing children survive
  // until the user picks a valid option.
  getChildElements: (element) =>
    getValueFromConditionalNodes(element, [productIds], false),
  getElementPropertySelectionByProductId: (productId: ProductID) =>
    getElementPropertySelectionByValue(productId, productIds),
};
